/**
 * Legal document URL paths appended to the Connect portal base URL.
 * The base URL is environment-specific (injected via CONNECT_PORTAL_URL token).
 */
export const LEGAL_URLS = {
  termsOfUseGtc: '/terms-of-use?section=gtc',
  termsOfUseTos: '/terms-of-use?section=tos',
  privacyPolicy: '/privacy-policy',
  dataProcessingAgreement:
    'https://www.allplan.com/fileadmin/user_upload/countries/international/pdfs/legal/AV_ALLPLAN_alle_Verarbeitungen_mit_Anlagen_en-01062025.pdf',
} as const;
